var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -541,
    y: -1928,
    width: 1253,
    height: 2360,
    rx: 48,
    fill: "#5E636C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template-Visual-Principles"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -437,
    y: -180,
    width: 701,
    height: 508,
    rx: 24,
    fill: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sections"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -413,
    y: -60,
    width: 653,
    height: 348,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 219,
    height: 69,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Country=DE",
    clipPath: "url(#clip0_3_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.932739 20.2174C3.05213 25.9293 8.55027 30.0001 14.9997 30.0001C21.4492 30.0001 26.9473 25.9293 29.0668 20.2174L14.9997 18.9131L0.932739 20.2174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9997 0C8.55027 0 3.05213 4.07063 0.932739 9.78263L14.9997 11.0869L29.0668 9.78257C26.9473 4.07062 21.4492 0 14.9997 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.932989 9.78271C0.330058 11.4077 0 13.1653 0 15.0001C0 16.8349 0.330058 18.5924 0.932989 20.2174H29.0671C29.67 18.5924 30 16.8349 30 15.0001C30 13.1653 29.67 11.4077 29.067 9.78271H0.932989Z",
    fill: "#D80027"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/Germany.e0806d7933244aebcb3bc3cbc2a42a12.svg";
export { ForwardRef as ReactComponent };